import { Button, Grid, Link, TextField, Typography } from "@mui/material";
import { Autocomplete } from '@mui/material';
import { useReducer } from "react";
import { Firmware, HardwareType } from "../../api/api-generated";
import { useFindAllFirmwareForUserQuery } from "../../api/api-hooks";
import LinkNewTab from "../../components/LinkNewTab";
import useStyles from "./hardwareDisplayStyles";

interface Props {
  hardwareType: HardwareType;
}

interface DownloadFormType {
  firmware: Firmware | null | undefined;
}

const initialFormState: DownloadFormType = {
  firmware: undefined,
};

const FirmwareDownloadForm = ({ hardwareType }: Props) => {
  const classes = useStyles();
  const { data: firmware } = useFindAllFirmwareForUserQuery({});
  const [formState, setFormState] = useReducer(
    (curVals: any, newVals: any) => ({ ...curVals, ...newVals }),
    initialFormState
  );
  if (firmware === undefined) return null;
  const filteredFirmware = firmware.filter((f) => {
    return f.hardwareTypeId === hardwareType.id;
  });
  const handleFormChange = (
    event: any,
    autoboxValue: object,
    label: string
  ) => {
    if (label === "firmware" && autoboxValue === null) {
      setFormState({
        firmware: null,
      });
    } else {
      setFormState({
        [label]: autoboxValue,
      });
    }
  };

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="flex-start"
      spacing={2}
      className={classes.formContainer}
    >
      <Grid item>
        <Typography variant="h5">Download Firmware</Typography>
      </Grid>
      <Grid item>
        <Autocomplete
          onChange={(event, autoboxValue) => {
            handleFormChange(event, autoboxValue, "firmware");
          }}
          value={formState.firmware}
          options={filteredFirmware}
          getOptionLabel={(firmware) => firmware.name}
          style={{ width: "300px" }}
          renderInput={(params) => (
            <TextField {...params} label="Select Firmware" variant="outlined" />
          )}
        />
      </Grid>
      <Grid item>
        <Link
          href={formState.firmware ? formState.firmware.link : ""}
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          underline="hover">
          <Button
            variant="contained"
            color="primary"
            disabled={!formState.firmware}
          >
            Download
          </Button>
        </Link>
        {formState.firmware && (
          <>
            {formState.firmware.changelog && (
              <Button color="primary">
                <LinkNewTab
                  href={formState.firmware.changelog}
                  label="Changelog"
                />
              </Button>
            )}
            {formState.firmware.userguideLink && (
              <Button color="primary">
                <LinkNewTab
                  href={formState.firmware.userguideLink}
                  label="User Guide"
                />
              </Button>
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default FirmwareDownloadForm;
